import type { T } from '../../i18n';

interface Props {
  t: T;
  theme: 'light' | 'dark';
  lang: 'zh' | 'en';
  onToggleTheme: () => void;
  onToggleLang: () => void;
  onNavHome: () => void;
}

export function Header({ t, theme, lang, onToggleTheme, onToggleLang, onNavHome }: Props) {
  return (
    <header className="header">
      <div className="brand" style={{ cursor: 'pointer' }} onClick={onNavHome}>
        <span className="brand-mark">A·v</span>
        <span className="brand-title">{t('app.title')}</span>
        <span className="brand-sub">— {t('app.sub')}</span>
      </div>
      <div className="header-actions">
        <button className="iconbtn" onClick={onToggleLang} title="Language">
          {lang === 'zh' ? '中 / EN' : 'EN / 中'}
        </button>
        <button className="iconbtn" onClick={onToggleTheme} title="Theme">
          {theme === 'light' ? '◐' : '◑'} {t(theme === 'light' ? 'theme.light' : 'theme.dark')}
        </button>
        <a
          className="iconbtn"
          href="https://github.com/kenjihiranabe/The-Art-of-Linear-Algebra"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: 'none' }}
        >
          ↗ source
        </a>
      </div>
    </header>
  );
}
